import { Helmet } from "react-helmet";
import withCustomAuthenticationRequired from "../../auth/withCustomAuthenticationRequired";
import Loader from "../../components/Loader";
import styles from "./creditreport.module.css";
import Footer from "../../components/Footer";
import { useEffect, useMemo, useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography } from "@mui/material";
import { ChevronDown, ChevronUp, Code, Download, Search, X } from "react-feather";
import TenantRow from "./components/TenantRow";
import GoalRow from "./components/GoalRow";
import TierRow from "./components/TierRow";
import SkylineBar from "./components/SkylineBar";
import KpiCard from "./components/KpiCard";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { DashCardLoaderSmall } from "../../components/LoaderC";
import ExportPdfButton from "./components/ExportPdfButton";

const TIER_DEFS = [
    { name: "Building", range: "300–579", min: 300, max: 579, color: "#7c72cc" },
    { name: "Fair", range: "580–669", min: 580, max: 669, color: "#e8a93c" },
    { name: "Good", range: "670–739", min: 670, max: 739, color: "#f2c438" },
    { name: "Excellent", range: "740–850", min: 740, max: 850, color: "#1d9e75" },
];

const GOAL_TYPE_LABELS = {
    EmergencyFund: "Emergency fund",
    OpenABankAccount: "Open a bank account",
    BuildCreditHistory: "Build credit history",
    PayDownDebt: "Pay down debt",
    SaveForAHouse: "Save for a house",
    SaveForACar: "Save for a car",
};

const GOAL_ICON_MAP = {
    EmergencyFund: { iconBg: "#FEF3C7", icon: <svg width="21px" height="16px" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 251.5 347.92"><path d="M3.23,313.83c-1.19-1.12-.71-2.58-.71-3.89,0-62.53-.16-125,.09-187.58C2.67,109.13,6.68,97,16.39,87.18c6.91-7,13-14.79,14.8-25a55.19,55.19,0,0,0,1.22-12.94C33.74,47.75,35.57,48,37.28,48q76-.06,152,0a9.42,9.42,0,0,1,4.39.69c1.44,1,1.4,2.58,1.48,4.05.64,12.09,4.82,22.56,13.57,31.16,12.27,12,16.52,27,16.44,43.93-.22,47.73-.07,95.47-.09,143.2,0,2.22.4,4.52-.83,6.59-1.64,1-2-.52-2.34-1.38-6.08-13.68-16.42-23.64-28.14-32.36-13.09-9.74-27.13-17.69-43-22-5.41-1.48-10.92-2.57-16.59-2.21-5.92.37-11,2.33-13.66,8.16-2.7,3.68-4.9,7.69-7.44,11.47-1.2,1.79-2.5,3.4-4.87,3.57-7-.4-13.9-1-20.86-.62-14.35.82-28.51,2.57-41.61,9.15A53,53,0,0,0,41,254.18c-5.25,3.38-8.14,7.95-7.46,14.4.09,5.59.13,11.18.07,16.77-.26,4.86,0,9.74-.12,14.61-.08,4.34,1.82,7.63,5.05,10.38a45,45,0,0,0,17.24,8.72,132.07,132.07,0,0,0,73.06.05c5.17-1.45,10.21-3.39,14.53-6.73,2.21-1.71,4.15-1.46,6.52-.22,10.1,5.27,20.52,9.69,31.9,11.44a46.45,46.45,0,0,0,10.06.34,14.32,14.32,0,0,0,11.7-7.06c5.31-8.31,10.53-16.68,15.88-25,1.54-1.44,1.71-4.38,4.67-4.27,1.25,1.5,1,3.29.89,5a43.12,43.12,0,0,1-42.83,39.5c-37.61.08-75.22,0-112.84,0-9.09,0-18.19-.19-27.27,0C25.93,332.62,12.84,327,3.23,313.83Z" transform="translate(-2.42 -1.15)" fill="#ededed" /><path d="M223.4,277.82c1-1.22.55-2.65.55-4,0-50.35.16-100.69-.07-151-.06-13.27-3.92-25.41-13.54-35.32-7-7.17-13.26-14.93-15-25.28A61.81,61.81,0,0,1,194,49.27c2.79-2.21,6.05-1,9.11-1.25,5.33,0,10.67-.19,16-.05,1.7,0,3.53-.22,4.85,1.3-.18,13.71,4,25.58,14,35.36,11.06,10.83,16,24.25,16,39.71q-.1,91.82,0,183.64c0,19.3-15,37-34,40.37a51,51,0,0,1-8.89.72q-84.33,0-168.67,0c-18.65,0-37.66-17.22-39.11-35.21.21-1.54.63-.83,1.14-.13a41.43,41.43,0,0,0,20.38,15,35,35,0,0,0,11.61,2.32c49,0,98,.19,147-.07,19.79-.11,37-15.32,39.93-35.08.4-2.79,1.49-5.54,0-8.33A19.63,19.63,0,0,1,223.4,277.82Z" transform="translate(-2.42 -1.15)" fill="#dfdfdf" /><path d="M203.07,49l-9,.24c-1.49,0-3-.12-4.47-.12H36.88c-1.49,0-3,.08-4.47.12l-5.6-.13c-7.24-.16-12.24-5-12.32-12.26-.09-7.74-.07-15.49,0-23.23.06-7.49,5-12.43,12.47-12.47,12.21-.06,24.43,0,36.64,0H199.34c1.24,0,2.49.07,3.73.11C209.34,2.61,212.81,6.5,213,13q.33,12.15,0,24.32C212.83,43.64,209.21,47.72,203.07,49Z" transform="translate(-2.42 -1.15)" fill="#ee5350" /><path d="M203.07,49c6.35-2.79,9.4-7.44,9-14.59a158.28,158.28,0,0,1,0-18.61c.43-7.17-2.61-11.81-9-14.55,9.32,0,18.65-.19,28-.06a11.5,11.5,0,0,1,10.83,10.83q.24,13.08,0,26.17c-.1,5.76-5.35,10.71-11.17,10.92-2.24.07-4.47.09-6.71.13Z" transform="translate(-2.42 -1.15)" fill="#e43935" /><path d="M114.07,191.42A60,60,0,0,1,68.48,138C66,110.81,83.1,85.07,109.09,76.3c1.64-.56,3.32-1,5-1.48,15.92,3.56,27.46,13.08,36,26.63.64,1,1.9,2.26.1,3.45-4.18-.94-8.42-.74-12.65-.72-2.93,0-4.42-1.26-4.37-4.26a15.16,15.16,0,0,0-.22-3.36c-.51-2.49-2-4.07-4.57-4.14s-4.84,1.4-4.7,3.83c.34,6-2.88,7.86-8,9.56-7.32,2.45-11.5,10.84-10.13,18.13A17.43,17.43,0,0,0,121.47,138c3.86.22,7.73,0,11.59.1,5,.17,8,2.85,8,7s-3,6.89-8,7c-6.48.14-13,0-19.44,0a21.14,21.14,0,0,0-3.73.17c-2.65.48-4.34,2-4.36,4.77s1.67,4.36,4.33,4.77,5.48.12,8.22.19c4.38.13,4.92.65,5.16,5a14.94,14.94,0,0,0,.26,3,4.53,4.53,0,0,0,4.49,3.79c2.59.08,4.91-1.39,4.71-3.79-.51-6.38,3.37-7.89,8.29-9.7,7.11-2.63,11.15-10.84,9.81-18A17.42,17.42,0,0,0,135,128.24c-3.86-.23-7.73,0-11.59-.1-5-.17-8-2.84-8-7s3-6.92,8-7c6.36-.13,12.71,0,19.07,0,6.62,0,7-.27,9.39-6.21,2-.79,2.29.95,2.71,2,8.4,22.13,5.46,42.69-8.92,61.45a57.13,57.13,0,0,1-25,18.42A44.83,44.83,0,0,1,114.07,191.42Z" transform="translate(-2.42 -1.15)" fill="#feb64d" /><path d="M220.25,292.07c-5.7,9.06-11.31,18.18-17.14,27.16-2.84,4.36-7.43,5.61-12.34,5.81-13.08.53-25-3.74-36.32-9.64-5.44-2.84-9.31-3.34-14.86.19-8.78,5.59-19.21,7.31-29.47,8.5-17.92,2.08-35.74,1.44-53.21-3.6-6.84-2-13.4-4.61-19-9.25-3.62-3-5.83-6.65-5.56-11.64.24-4.48.11-9,.15-13.47a1.7,1.7,0,0,1,1.8,1.05C38,293.36,44,296.55,50.27,299c16.93,6.45,34.52,8.14,52.5,6.62,4-.34,7.93-.78,11.3-3.28a16.52,16.52,0,0,0,3.07-2.71c3.46-4.17,3.42-5.17-.42-9-.79-.79-1.61-1.56-2.38-2.37-3.33-4.19-6.93-8.16-9.78-12.72a36.2,36.2,0,0,1-4.34-9.49c-1.19-4.25-1-8.39,1.4-12.24s4.51-8,7.75-11.32c1.7-.07,1.69,1.31,1.71,2.33.19,9.25,5.29,16.17,10.89,22.76,9.79,11.52,21.78,20.36,34.77,27.88,4.74,2.74,9.58,5.3,15.47,4.19a17.65,17.65,0,0,0,10.85-6.72c.92-1.16,1.7-2.5,3.27-2.94s2.93.31,4.35.7c5.75,1.56,11.5,2.9,17.54,2.65a29.28,29.28,0,0,0,9.46-1.52C218.39,291.53,219.62,290.08,220.25,292.07Z" transform="translate(-2.42 -1.15)" fill="#fec928" /><path d="M220.25,292.07c-10.38,4.15-20.63,2.34-30.86-.68-1.17-.35-2.38-.56-3.58-.83a18.64,18.64,0,0,1-7.08-2.16c-17.46-8-33.27-18.4-46.45-32.53-5.39-5.79-9.87-12.17-12.37-19.79a12.17,12.17,0,0,1,0-8.75c2.55-6.6,8.09-8.39,14.34-8.68,9.91-.45,19.23,2.32,28.2,6.09,19.64,8.25,37.07,19.76,51,36.12,4.31,5.05,7.95,10.54,10,17a17.66,17.66,0,0,1-.1,9.75Z" transform="translate(-2.42 -1.15)" fill="#feb64d" /><path d="M150.58,104.75c-2.71-6.23-7-11.23-11.87-15.87-7.06-6.75-15.8-10.46-24.63-14.06,23.42-6.12,49,3.51,63.14,23.73a60.11,60.11,0,0,1,.22,68.83c-14.22,20.48-39.77,30.17-63.37,24,6.71-3.12,13.77-5.41,19.78-10.06,13.29-10.28,21.14-23.53,23.61-40.22,1.58-10.65-.12-20.7-3.74-30.62a5.79,5.79,0,0,0-1.57-2.89A2.32,2.32,0,0,1,150.58,104.75Z" transform="translate(-2.42 -1.15)" fill="#fea626" /><path d="M109.56,242.67a67.23,67.23,0,0,1-4.54,7.27c-6.81,8.37-5.06,16.49.14,24.79,2.85,4.56,6.65,8.36,9.59,12.82-1.36,1.37-3.22,1.33-4.89,1.51-19.77,2.22-39.26,1.31-58.22-5.33a51.93,51.93,0,0,1-13.18-6.93c-3.08-2.2-5.28-4.88-5.91-8.7-.82-5.65,1.46-9.88,5.8-13.32,8.27-6.56,18.06-9.38,28.12-11.31a132.29,132.29,0,0,1,42.35-1.36A.83.83,0,0,1,109.56,242.67Z" transform="translate(-2.42 -1.15)" fill="#feb64d" /><path d="M109.56,242.67l-.74-.57c1.63-.32,2.32-1.65,3.13-2.87q3.94-6,7.92-11.9c-.47,11.43,5.77,19.82,12.88,27.61,13,14.26,28.91,24.56,46.31,32.66,2.23,1,4.9,1.06,6.75,3-3.22,5.34-7.46,9.1-13.95,10.11-6.19,1-11.12-1.86-16.06-4.67a135.56,135.56,0,0,1-28.61-21.28c-6.69-6.62-12.78-13.86-16.16-23C109.91,248.71,111.09,245.5,109.56,242.67Z" transform="translate(-2.42 -1.15)" fill="#fed44f" /><path d="M32.55,268.1c3.48,7.27,10.06,10.87,17,13.7,9.58,3.9,19.68,5.58,30,6.66,11.84,1.24,23.51.16,35.23-.91,1.93,1.74,3.82,3.55,5.82,5.2,1,.86.79,1.64.36,2.62a17.61,17.61,0,0,1-14,10.91,93,93,0,0,1-20.42.71c-13.88-.76-27.59-2.58-40.33-8.78-5.7-2.76-10.64-6.28-13.61-12.08Q32.55,277.12,32.55,268.1Z" transform="translate(-2.42 -1.15)" fill="#fed44f" /><path d="M150.58,104.75l1.57,2.88c-.22,5.69-2.07,7.48-7.82,7.49-7,0-14,0-20.93,0-4.5,0-7.08,2.19-7.15,5.88s2.6,6.06,7.3,6.1c3.37,0,6.73,0,10.1,0,9.47.07,17.32,6.81,18.41,15.79a17.88,17.88,0,0,1-14.46,19.74c-3.19.63-3.81,1.93-3.43,4.63a8.36,8.36,0,0,1,0,1.87c-.28,3.57-2.67,5.93-6,5.92s-5.68-2.37-6-5.94c-.48-6-.48-6-6.55-6-1.5,0-3,0-4.49,0-4.37-.09-7-2.42-6.91-6.12s2.59-5.83,6.79-5.86c7.23,0,14.45,0,21.68,0,4.76,0,7.41-2.21,7.39-6s-2.65-5.93-7.44-6c-3.36,0-6.73,0-10.09,0-9.41-.09-17.3-7-18.28-15.93a17.86,17.86,0,0,1,14.59-19.63c3.1-.59,3.52-1.85,3.31-4.36a11.82,11.82,0,0,1,.14-3.36,5.92,5.92,0,0,1,6.34-4.66c3.13.27,5.22,2.59,5.46,6.06.41,5.9.41,5.85,6.3,5.92C143.9,103.2,147.49,102.41,150.58,104.75Z" transform="translate(-2.42 -1.15)" fill="#ededed" /></svg> },
    OpenABankAccount: { iconBg: "#E0F2FE", icon: <svg width="21px" height="16px" viewBox="0 0 359.32 316.91" xmlns="http://www.w3.org/2000/svg"><path d="M37.49,139c-7.13-1.1-9.72-4.08-9.73-11.17,0-.87,0-1.74,0-2.62,0-2.36.69-5.12-.29-7-1.18-2.26-4.28-.56-6.49-1.11-4.15-1-6.78-3.56-7.68-7.73a9,9,0,0,1,4.11-10c8.84-5.81,17.78-11.47,26.7-17.17q60.6-38.67,121.16-77.39c9.85-6.34,19-6.37,28.85,0q73.07,46.89,146.32,93.51c6.36,4.06,7.86,10.3,3.73,15.42-2.42,3-5.72,3.88-9.37,3.53-2.43-.23-3.37.58-3.15,3.09.2,2.35,0,4.73,0,7.1,0,7.78-2.67,10.77-10.4,11.66-1.78,1.18-3.8,1-5.77,1-10.9-.29-21.8,0-32.69-.12-8-.44-11.37-3.94-11.43-11.94-.08-11,1.08-9.61-9.79-9.72-2.48,0-5,0-7.45,0-2,0-2.93,1-3,3s0,4.22,0,6.33c-.07,8.09-3.92,12-12,12.36-12.64,0-25.27,0-37.91,0-7.89-.47-11.29-4-11.36-11.64,0-2.24,0-4.48,0-6.72-.05-2.08-.94-3.25-3.14-3.27-4.6-.05-9.2,0-13.8,0-2.14,0-3.17,1-3.22,3.19s0,4.23-.05,6.34c0,8.37-3.49,11.84-12,12.13-12.64,0-25.28,0-37.91,0-7.57-.45-11.26-4.29-11.36-11.83,0-2.23,0-4.47,0-6.71s-1.07-3.12-3.22-3.12c-4.47,0-9,0-13.42,0-2.53,0-3.59,1.2-3.57,3.65,0,2.11,0,4.22,0,6.33-.07,7.72-3.43,11.17-11.34,11.68-11.63,0-23.26,0-34.89,0C40.31,139.86,39,139.16,37.49,139Z" fill="#2b4c9e" /><path d="M345.92,287.66c10.17,2.83,13.38,7.06,13.38,17.66,0,3.12-.06,6.24,0,9.35,0,1.59-.46,2.34-2.12,2.17a21.09,21.09,0,0,0-2.25,0q-175.21,0-350.43.09c-3.61,0-4.91-.83-4.42-4.46a50.34,50.34,0,0,0,0-6.73c0-11,2.88-14.93,13.33-18.11,2.24-1.55,4.8-1.09,7.26-1.09q123.15,0,246.29,0h66.53a33.52,33.52,0,0,1,4.48.11C340.7,286.7,343.47,286,345.92,287.66Z" fill="#2b4c9e" /></svg> },
    BuildCreditHistory: { iconBg: "#FEF9C3", icon: <svg width="21px" height="16px" viewBox="0 0 100 60" xmlns="http://www.w3.org/2000/svg"><rect x="5" y="5" width="90" height="50" rx="5" fill="#42ac72" /><rect x="5" y="18" width="90" height="12" fill="#2e8b57" /><rect x="12" y="35" width="20" height="6" rx="2" fill="#fff" opacity="0.7" /><rect x="38" y="35" width="30" height="6" rx="2" fill="#fff" opacity="0.4" /></svg> },
    PayDownDebt: { iconBg: "#EDE9FE", icon: <svg width="21px" height="16px" viewBox="0 0 100 60" xmlns="http://www.w3.org/2000/svg"><circle cx="50" cy="30" r="22" fill="#f97316" opacity="0.2" /><text x="50" y="36" textAnchor="middle" fontSize="18" fill="#f97316" fontWeight="bold">$</text></svg> },
    SaveForAHouse: { iconBg: "#FCE7E7", icon: <svg width="21px" height="16px" viewBox="0 0 100 60" xmlns="http://www.w3.org/2000/svg"><polygon points="50,8 90,38 10,38" fill="#e94756" opacity="0.8" /><rect x="30" y="38" width="40" height="18" fill="#e94756" /><rect x="42" y="44" width="16" height="12" fill="#fff" opacity="0.5" /></svg> },
    SaveForACar: { iconBg: "#DCFCE7", icon: <svg width="21px" height="16px" viewBox="0 0 100 60" xmlns="http://www.w3.org/2000/svg"><rect x="10" y="22" width="80" height="24" rx="8" fill="#008cb2" /><circle cx="28" cy="46" r="8" fill="#444" /><circle cx="72" cy="46" r="8" fill="#444" /><polygon points="20,22 30,10 70,10 80,22" fill="#008cb2" opacity="0.7" /></svg> },
};

const tierForScore = (score) => {
    return TIER_DEFS.find(t => score >= t.min && score <= t.max) || TIER_DEFS[0];
}

const mapResidentToRow = (resident) => {
    const scores = [...(resident.credit_scores || [])].sort((a, b) => new Date(a.month) - new Date(b.month));
    const scoreOld = resident.credit_score || 0;
    const scoreNew = scores.length ? scores[scores.length - 1].score : scoreOld;
    const pts = scoreNew - scoreOld;
    const tier = tierForScore(scoreNew);

    const goals = (resident.financial_goals || []).map(g => ({
        label: GOAL_TYPE_LABELS[g.goal_type] || g.goal_type,
        pct: g.percentage || 0,
    }));

    return {
        id: resident.id,
        avatar: resident.user_image || "/static/img/avatars/avatar-4.jpg",
        name: `${resident.full_name}`,
        sub: resident.phone ? resident.phone : '',
        scoreOld,
        scoreNew,
        pts: pts >= 0 ? `+${pts}` : `${pts}`,
        ptsType: pts >= 0 ? "up" : "down",
        tierLabel: tier.name,
        tierCls: `chip${tier.name}`,
        goals: goals.length ? goals : [{ label: "No goal set", pct: 0 }],
    };
}

const mapResidentToRow2 = (resident) => {
    const scores = [...(resident.credit_scores || [])].sort((a, b) => new Date(a.month) - new Date(b.month));
    const scoreOld = resident.credit_score || 0;
    const scoreNew = scores.length ? scores[scores.length - 1].score : scoreOld;
    const pts = scoreNew - scoreOld;
    const tier = tierForScore(scoreNew);

    const goals = (resident.financial_goals || []).map(g => ({
        label: GOAL_TYPE_LABELS[g.goal_type] || g.goal_type,
        pct: g.percentage || 0,
    }));

    return {
        id: resident.id,
        avatar: resident.user_image || "/static/img/avatars/avatar-4.jpg",
        name: `${resident.full_name}`,
        sub: resident.phone ? resident.phone : '',
        scoreOld,
        scoreNew,
        pts: pts >= 0 ? `+${pts}` : `${pts}`,
        ptsType: pts >= 0 ? "up" : "down",
        tierLabel: tier.name,
        tierCls: `chip${tier.name}`,
        goals: goals.length ? goals : [],
    };
}

const CreditReport = () => {
    const { getAccessTokenSilently } = useAuth0();
    const [tenantAddOpen, setTenantAddOpen] = useState(false);
    const [initialLoading, setInitialLoading] = useState(true);
    const [tenantList, setTenantList] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
    const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const [totalCount, setTotalCount] = useState(0);
    const [initialTierLoading, setInitialTierLoading] = useState(true);
    const [tierList, setTierList] = useState([]);
    const [initialGoalLoading, setInitialGoalLoading] = useState(true);
    const [goalList, setGoalList] = useState([]);
    const [initialChartLoading, setInitialChartLoading] = useState(true);
    const [chartData, setChartData] = useState([]);
    const [kpiData, setKpiData] = useState([]);

    useEffect(() => {
        const handle = setTimeout(() => {
            setDebouncedSearchTerm(searchTerm);
            setPage(0);
        }, 400);
        return () => clearTimeout(handle);
    }, [searchTerm]);

    useEffect(() => {
        const getTierList = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            axios(process.env.REACT_APP_TENANT_API_URL + "v1/credit-builder/tier-distribution", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then((response) => {
                setTierList(response.data.data);
            }).catch(() => {
            }).finally(() => {
                setInitialTierLoading(false);
            });
        };

        getTierList();
    }, [getAccessTokenSilently]);

    useEffect(() => {
        const getGoalList = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            axios(process.env.REACT_APP_TENANT_API_URL + "v1/credit-builder/goal-breakdown", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then((response) => {
                setGoalList(response.data.data);
            }).catch(() => {
            }).finally(() => {
                setInitialGoalLoading(false);
            });
        };

        getGoalList();
    }, [getAccessTokenSilently]);

    useEffect(() => {
        const getChartData = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            axios(process.env.REACT_APP_TENANT_API_URL + "v1/credit-builder/score-trend", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then((response) => {
                setChartData(response.data.data);
            }).catch(() => {
            }).finally(() => {
                setInitialChartLoading(false);
            });
        };

        getChartData();
    }, [getAccessTokenSilently]);

    useEffect(() => {
        const getKPIData = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            axios(process.env.REACT_APP_TENANT_API_URL + "v1/credit-builder/kpi-summary", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then((response) => {
                let kpiDataTemp = response.data.data;
                setKpiData([
                    {
                        iconBg: "#efebf9",
                        icon: (<svg width="17" height="17" viewBox="0 0 18 18" fill="none">
                            <circle cx="6" cy="5.5" r="2.5" stroke="#392978" strokeWidth="1.4" />
                            <path d="M1.5 14c0-2.5 2-4.5 4.5-4.5s4.5 2 4.5 4.5" stroke="#392978" strokeWidth="1.4" strokeLinecap="round" />
                            <circle cx="12.5" cy="6" r="2" stroke="#392978" strokeWidth="1.2" />
                            <path d="M11.3 9.6c1.9.4 3.2 2 3.2 3.9" stroke="#392978" strokeWidth="1.2" strokeLinecap="round" />
                        </svg>),
                        value: String(kpiDataTemp.residents_enrolled.value),
                        label: "Residents enrolled",
                        delta: kpiDataTemp.residents_enrolled.delta_count > 0 ? `↑ ${kpiDataTemp.residents_enrolled.delta_count} this month` : "",
                        deltaType: kpiDataTemp.residents_enrolled.delta_count > 0 ? "up" : "flat",
                    },
                    {
                        iconBg: "#fde9e5",
                        icon: (<svg width="17" height="17" viewBox="0 0 18 18" fill="none">
                            <path d="M2 13l3.5-4 3 2.5L13 6l3-2" stroke="#f48272" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M12.5 4h3.5v3.5" stroke="#f48272" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>),
                        value: `${kpiDataTemp.avg_score_increase.value >= 0 ? "+" : ""}${kpiDataTemp.avg_score_increase.value}`,
                        label: "Avg. score increase",
                        delta: `↑ ${kpiDataTemp.avg_score_increase.improved_pct}% of cohort improved`,
                        deltaType: "up",
                    },
                    {
                        iconBg: "#e3f0ee",
                        icon: (<svg width="17" height="17" viewBox="0 0 18 18" fill="none">
                            <circle cx="9" cy="9" r="6.5" stroke="#1d4f4a" strokeWidth="1.4" />
                            <path d="M9 5.5v3.5l2.5 2" stroke="#1d4f4a" strokeWidth="1.4" strokeLinecap="round" />
                        </svg>),
                        value: `${kpiDataTemp.goals_halfway.value_pct}%`,
                        label: "Goals at 50%+ progress",
                        delta: `↑ ${kpiDataTemp.goals_halfway.count} residents past halfway`,
                        deltaType: "up",
                    },
                    {
                        iconBg: "#fbf0dc",
                        icon: (<svg width="17" height="17" viewBox="0 0 18 18" fill="none">
                            <rect x="2.5" y="6" width="13" height="9" rx="1.5" stroke="#e8a93c" strokeWidth="1.4" />
                            <path d="M5.5 6V4.5a3.5 3.5 0 0 1 7 0V6" stroke="#e8a93c" strokeWidth="1.4" strokeLinecap="round" />
                        </svg>),
                        value: String(kpiDataTemp.bank_accounts_opened.value),
                        label: "New bank accounts opened",
                        delta: "",
                        deltaType: "flat",
                    },
                ]);
            }).catch(() => {
            }).finally(() => { });
        };

        getKPIData();
    }, [getAccessTokenSilently]);

    useEffect(() => {
        const getTenantList = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            axios(process.env.REACT_APP_TENANT_API_URL + "v1/credit-builder/tenant-list", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                params: {
                    search: debouncedSearchTerm,
                    sort_by: sortConfig.key || undefined,
                    sort_direction: sortConfig.direction,
                    page: page + 1,
                    per_page: rowsPerPage,
                }
            }).then((response) => {
                const paginator = response.data.data;
                const rows = Array.isArray(paginator) ? paginator : (paginator?.data || []);
                setTenantList(rows);
                setTotalCount(Array.isArray(paginator) ? rows.length : (paginator?.total || 0));
            }).catch(() => {
            }).finally(() => {
                setInitialLoading(false);
            });
        };

        getTenantList();
    }, [getAccessTokenSilently, debouncedSearchTerm, sortConfig, page, rowsPerPage]);

    useEffect(() => {
        console.log('tenantList');
        console.log(tenantList);
    }, [tenantList]);

    const residents = useMemo(() => tenantList.map(mapResidentToRow), [tenantList]);

    const goals = goalList.map(g => ({
        label: g.label,
        pct: g.pct,
        ...(GOAL_ICON_MAP[g.goal_type] || { iconBg: "#eee", icon: null }),
    }));

    const handleSort = (key) => {
        setSortConfig((prev) => {
            if (prev.key !== key) return { key, direction: "asc" };
            return { key, direction: prev.direction === "asc" ? "desc" : "asc" };
        });
        setPage(0);
    };

    const sortIconFor = (key) => {
        if (sortConfig.key !== key) return <Code className={styles.Normal} />;
        return sortConfig.direction === "asc" ? <ChevronDown size={16} /> : <ChevronUp size={16} />;
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0); // changing page size resets to page 1 to avoid landing on an out-of-range page
    };

    return (<>
        <Helmet title="Credit to Wealth Report" />

        <div className={styles.mainCard}>

            <div className={styles.pageTitleWrap}>
                <Typography display="inline" className={styles.pageTitle}>Credit to Wealth Report</Typography>

                <ExportPdfButton
                    getAccessTokenSilently={getAccessTokenSilently}
                    propertyName="PropertyDek"
                    //dateRangeLabel="Apr 1 - Sep 30, 2026"
                    dateRangeLabel=""
                    kpiData={kpiData}
                    chartData={chartData}
                    tierList={tierList}
                    goals={goals}
                    mapResidentToRow={mapResidentToRow2}
                />
            </div>

            <div className={styles.CenterBlockSec}>
                <div className={styles.Row}>

                    <div className={styles.CashFlowSec}>

                        {/* KPI CARDS */}
                        <div className={styles.section}>
                            <div className={styles.kpiGrid}>
                                {kpiData.map((k, i) => <KpiCard key={i} {...k} />)}
                            </div>
                        </div>

                        {/* SKYLINE CHART */}
                        <div className={styles.section}>
                            <div className={styles.sectionHead}>
                                <p className={styles.sectionTitle}>Cohort credit score trend</p>
                                <p className={styles.sectionNote}>Average score across all enrolled residents, by month</p>
                            </div>
                            <div className={styles.chartCard}>
                                <div className={styles.chartLegend}>
                                    <div className={styles.legendItem}>
                                        <div className={styles.legendDot} style={{ background: "#392978" }} />
                                        Monthly average score
                                    </div>
                                    <div className={styles.legendItem}>
                                        <div className={styles.legendDot} style={{ background: "#f48272" }} />
                                        Marker = average score that month
                                    </div>
                                </div>
                                <div className={styles.skyline}>
                                    {initialChartLoading && <DashCardLoaderSmall />}
                                    {!initialChartLoading && chartData.map((d, i) => <SkylineBar key={i} {...d} />)}
                                </div>
                            </div>
                        </div>

                        {/* TIER + GOAL BREAKDOWN */}
                        <div className={styles.section}>
                            <div className={styles.twoCol}>
                                <div className={styles.panel}>
                                    <p className={styles.panelTitle}>Credit score tier distribution</p>
                                    {initialTierLoading && <DashCardLoaderSmall />}
                                    {!initialTierLoading && tierList.map((t, i) => <TierRow key={i} {...t} />)}
                                </div>
                                <div className={styles.panel}>
                                    <p className={styles.panelTitle}>Financial goal breakdown</p>
                                    {initialGoalLoading && <DashCardLoaderSmall />}
                                    {!initialGoalLoading && goals.map((g, i) => <GoalRow key={i} {...g} />)}
                                </div>
                            </div>
                        </div>

                        {/* RESIDENT TABLE */}
                        <div className={styles.OfferListSec}>
                            <div className={styles.CashFlowCard}>
                                <div className={styles.OfferCardHead}>
                                    <div className={styles.OfferCardHeadTopSec}>
                                        <p className={styles.CardHeadTitle}>Resident progress detail</p>
                                        <div className={styles.SearchFilterSec}>
                                            <div className={styles.SearchCon}>
                                                <div className={styles.SearchConSec}>
                                                    <Search />
                                                    <input
                                                        type="text"
                                                        placeholder="Search"
                                                        value={searchTerm}
                                                        onChange={(e) => setSearchTerm(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className={styles.OfferTableSec}>
                                    {initialLoading && <DashCardLoaderSmall />}

                                    {!initialLoading && <TableContainer className={`${styles.TableDiv} CustomTableDiv`}>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell
                                                        className={styles.TableHead}
                                                        style={{ width: 250, cursor: "pointer", userSelect: "none" }}
                                                        onClick={() => handleSort("resident")}
                                                    >
                                                        Resident {sortIconFor("resident")}
                                                    </TableCell>
                                                    <TableCell
                                                        className={styles.TableHead}
                                                        style={{ width: 250, cursor: "pointer", userSelect: "none" }}
                                                        onClick={() => handleSort("score")}
                                                    >
                                                        Baseline → current {sortIconFor("score")}
                                                    </TableCell>
                                                    <TableCell
                                                        className={styles.TableHead}
                                                        style={{ width: 250, cursor: "pointer", userSelect: "none" }}
                                                        onClick={() => handleSort("pts")}
                                                    >
                                                        Pts {sortIconFor("pts")}
                                                    </TableCell>
                                                    <TableCell
                                                        className={styles.TableHead}
                                                        style={{ width: 250, cursor: "pointer", userSelect: "none" }}
                                                        onClick={() => handleSort("tier")}
                                                    >
                                                        Tier {sortIconFor("tier")}
                                                    </TableCell>
                                                    <TableCell
                                                        className={styles.TableHead}
                                                        style={{ width: 250 }}
                                                    >
                                                        Financial goal
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>

                                            <TableBody>
                                                {residents.length === 0 && (
                                                    <TableRow>
                                                        <TableCell colSpan={5} className={styles.TableBodyText}>
                                                            {searchTerm ? "No residents match your search." : "No residents with credit score or goal activity yet."}
                                                        </TableCell>
                                                    </TableRow>
                                                )}

                                                {residents.map(r => <TenantRow key={r.id} {...r} />)}
                                            </TableBody>
                                        </Table>

                                        {residents?.length > 0 && (<div className="Pagination TablePaginationNew List">
                                            <TablePagination
                                                component="div"
                                                count={totalCount}
                                                page={page}
                                                onPageChange={handleChangePage}
                                                rowsPerPage={rowsPerPage}
                                                onRowsPerPageChange={handleChangeRowsPerPage}
                                                rowsPerPageOptions={[
                                                    { label: "20", value: 20 },
                                                    { label: "50", value: 50 },
                                                    { label: "100", value: 100 },
                                                ]}
                                                labelRowsPerPage={"Tenants per page:"}
                                            />
                                        </div>)}
                                    </TableContainer>}
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        {/* Send message dialog */}
        <Dialog
            open={tenantAddOpen}
            fullWidth
            maxWidth="sm"
            onClose={() => setTenantAddOpen(false)}
            aria-labelledby="alert-dialog-title"
            className="NewPopUp"
        >
            <DialogTitle id="alert-dialog-title">
                Messages sent successfully!
                <button onClick={() => setTenantAddOpen(false)}><X /></button>
            </DialogTitle>
            <DialogContent>
                <div className="ModalFormGroup">
                    <p className="PopupBodyText">Renewal offers have been sent to the selected tenants.</p>
                    <p className={styles.ListTextPopup}>Recipients</p>
                    <ol className={styles.ListSecPopup}>
                        <li>Glenda Orlando</li>
                        <li>Doris Williams</li>
                        <li>Keith Lane</li>
                    </ol>
                </div>
            </DialogContent>
            <DialogActions>
                <Button className="AddPopupBU" onClick={() => setTenantAddOpen(false)}>Okay</Button>
            </DialogActions>
        </Dialog>

        <Footer />
    </>);
}

export default withCustomAuthenticationRequired(CreditReport, {
    onRedirecting: () => <Loader />,
});